import React, { useEffect } from 'react';
import cpmall from '../images/cpmall.jpg';
import regallia from '../images/regalliya.webp';
import heights from '../images/heights.jpg';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function Another({ id }) {

    useGSAP(() => {
        gsap.to(".slide", {
            xPercent: -200,
            ease: 'Power2.inOut',
            scrollTrigger: {
                trigger: ".project",
                start: "top top",
                end: "bottom bottom",
                scrub: 2,
                // mark:true,
                pin: true,
            }
        });
    }, []);

    const project = [
        {
            heading: 'CP67 Mohali - Lifestyle Redefined',
            text: 'An arena where customers love to live, work, shop, dine, and be entertained...',
            img: cpmall
        },
        {
            heading: 'HOMELAND HEIGHTS',
            text: 'Life today takes us across borders. Whether it be a quick business trip or a family getaway...',
            img: heights
        },
        {
            heading: 'Homeland regalia : The Most Powerful Address',
            text: 'Built with a vision to set a benchmark for luxury living, Homeland Regalia rises sky high...',
            img: regallia
        }
    ];

    return (
        <>
            <div id={ id } className='project w-full h-auto mt-16 relative'>
                <div className='heading flex w-full items-center justify-center gap-5 px-4 sm:px-8 lg:px-16'>
                    <div className='h-2 w-[15%] sm:w-[18%] border-b-[2px] border-black'></div>
                    <div>
                        <h2 className='text-2xl sm:text-3xl lg:text-4xl'>Previous Projects</h2>
                    </div>
                    <div className='h-2 w-[15%] sm:w-[18%] border-b-[2px] border-black'></div>
                </div>
                <div className='previous relative h-[200vh
                ] '>
                    <div className='slides flex gap-5 md:gap-20 w-full md:h-[100vh] sticky left-0 top-0 overflow-hidden'>
                        {project.map((value, index) => (
                            <div key={index} className='slide flex flex-col md:flex-row w-full items-center md:gap-36 md:justify-between h-auto md:h-screen flex-shrink-0 relative p-5 md:p-16'>
                                <div className='text flex flex-col w-full md:w-[55%]'>
                                    <h3 className='w-full text-2xl md:text-[1.5rem] font-["robecha-daniera"] md:leading-9'>{value.heading}</h3>
                                    <p className='text-sm md:text-base'>{value.text}</p>
                                </div>
                                <div className='image w-full md:w-[35rem] h-[20rem] md:h-[35rem] mt-5 md:mt-0 relative'>
                                    <img className='h-full w-full object-cover rounded-md shadow-2xl' src={value.img} alt={value.heading} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
